module.exports = __webpack_public_path__ + "static/media/p_1.75b26d50.jpg";